<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('Informe de')"
      :directory="$t('evaluación documental')"
      :icon="'trello'"
    />

    <div class="mb-primary">
      <div class="d-flex justify-content-between mb-3">
      </div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
    
  </div>
</template>


<script>
// import CopyButton from "CopyButton";

export default {
  name: "Tabs",
//   components: { CopyButton },
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "activity",
          name: "Informe de evaluación documental",
          component: "evaluation-report",
          permission: "",
        },

        
      ],
      
    };
  },
};
</script>
